import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxTypedJsModule } from 'ngx-typed-js';
import { NgParticlesModule } from 'ng-particles';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { PagesRoutingModule } from './pages-routing.module'

import { SharedModule } from '../shared/shared.module';
import { Index1Component } from './index1/index1.component';
import { Index2Component } from './index2/index2.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  declarations: [Index1Component, Index2Component],
  imports: [
    CommonModule,
    SharedModule,
    PagesRoutingModule,
    NgxTypedJsModule,
    NgParticlesModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxMaskModule.forRoot(),
    ProgressbarModule.forRoot(),
    TooltipModule.forRoot(),
    ButtonsModule.forRoot(),
    NgxPaginationModule
  ]
})
export class PagesModule { }
